import { render } from "./ShipmentItem.vue?vue&type=template&id=08c72c62&scoped=true"
import script from "./ShipmentItem.vue?vue&type=script&lang=js"
export * from "./ShipmentItem.vue?vue&type=script&lang=js"

import "./ShipmentItem.vue?vue&type=style&index=0&id=08c72c62&scoped=true&lang=css"

import exportComponent from "C:\\project\\webtrackandtrace\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c72c62"]])

export default __exports__